var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_64",
    "data-name": "Subtraction 64",
    d: "M-2288,14a5.006,5.006,0,0,1-5-5,5.006,5.006,0,0,1,5-5,5.006,5.006,0,0,1,5,5A5.006,5.006,0,0,1-2288,14Zm-1.78-5.554a.552.552,0,0,0-.391.162.55.55,0,0,0-.162.392.55.55,0,0,0,.162.392l1.187,1.186a.547.547,0,0,0,.391.163.548.548,0,0,0,.392-.163l2.373-2.373a.55.55,0,0,0,.162-.392.547.547,0,0,0-.162-.391.55.55,0,0,0-.392-.163.55.55,0,0,0-.391.163l-1.982,1.981-.8-.8A.549.549,0,0,0-2289.78,8.446Z",
    transform: "translate(2293 -4)",
    fill: "#3ea598"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginCheck);
export default __webpack_public_path__ + "static/media/LoginCheck.7a22d057e97db0dfa312ab7b1faebd33.svg";
export { ForwardRef as ReactComponent };